import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../src/components/ui/select";
import { Button } from "../../../src/components/ui/button";
import { Input } from "../../../src/components/ui/input";
import { Textarea } from "../../../src/components/ui/textarea";
import { Label } from "@radix-ui/react-label";
import React, { ChangeEvent, FormEvent } from "react";
import { apiCall } from "../../../src/lib/api";
import { Loader } from "lucide-react";

export default function Careers() {
  const [formData, setFormData] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    position: "",
    message: "",
    cv: null,
  });
  const [loading, setLoading] = React.useState(false);
  const positions = [
    { label: "Junior", value: "junior" },
    { label: "Senior", value: "senior" },
    { label: "Staff", value: "staff" },
  ];
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, files } =
      e.target as HTMLInputElement;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };
  const handleSelectChange = (value: string) => {
    setFormData((prev) => ({
      ...prev,
      position: value,
    }));
  };
  const handleSubmit = async (
    e: FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();
    data.append(
      "name",
      formData.firstName + formData.lastName
    );
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("position", formData.position);
    data.append("message", formData.message);
    if (formData.cv) data.append("cv", formData.cv);

    try {
      const response = await fetch(
        `${apiCall}/wp-json/career-form/v1/submit`,
        {
          method: "POST",
          body: data,
        }
      );

      if (!response.ok)
        throw new Error("Submission failed");
      setLoading(false);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        position: "",
        message: "",
        cv: null,
      });
    } catch (error) {
      setLoading(false);
      console.error("Form error:", error);
    }
  };
  return (
    <div className="lg:mt-36 mt-16 lg:pt-5 lg:pr-5 h-full">
      <div className="flex gap-10 lg:flex-row flex-col">
        <div className="relative flex flex-col justify-center items-center lg:size-1/2 size-full gap-5">
          <img
            src="/team.jpeg"
            alt="Team"
            className="bg-neutral-700 size-full lg:block hidden"
          />
          <img
            src="/team-mobile.jpeg"
            alt="Team"
            className="bg-neutral-700 size-full lg:hidden block mt-3"
          />
          <p className="hidden absolute bottom-0 w-full text-justify p-5 text-neutral-100 from-neutral-900 w-full bg-gradient-to-t">
            We believe in fostering an inclusive environment
            where creativity thrives and every voice
            matters. Our team is built on collaboration,
            continuous learning, and the passion to make a
            difference.
          </p>
        </div>
        <div className="flex flex-col justify-start w-full rounded-none lg:pl-5 lg:pr-5 p-2">
          <h1 className="text-xl font-medium text-left mb-5">
            JOIN OUR TEAM
          </h1>
          <form
            className="flex flex-col gap-4 w-full"
            onSubmit={handleSubmit}
          >
            <div>
              <Label>
                First Name{" "}
                <span className="text-red-500">*</span>
              </Label>
              <Input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                className={`text-neutral-900 focus:outline-none w-full dark:text-neutral-200 rounded-none`}
              />
            </div>
            <div>
              <Label>
                Last Name{" "}
                <span className="text-red-500">*</span>
              </Label>
              <Input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                className={`text-neutral-900 focus:outline-none w-full dark:text-neutral-200 rounded-none`}
              />
            </div>
            <div>
              <Label>
                Email{" "}
                <span className="text-red-500">*</span>
              </Label>
              <Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className={`text-neutral-900 focus:outline-none w-full dark:text-neutral-200 rounded-none`}
              />
            </div>
            <div>
              <Label>
                Phone{" "}
                <span className="text-red-500">*</span>
              </Label>
              <Input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className={`text-neutral-900 focus:outline-none w-full dark:text-neutral-200 rounded-none`}
              />
            </div>
            <div>
              <Label>
                Position{" "}
                <span className="text-red-500">*</span>
              </Label>
              <Select
                onValueChange={handleSelectChange}
                value={formData.position}
              >
                <SelectTrigger className="w-full rounded-none">
                  <SelectValue placeholder="Select a position" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    {positions.map((position) => (
                      <SelectItem
                        key={position.value}
                        value={position.value}
                      >
                        {position.label}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>
                Upload CV
                <span className="text-red-500">*</span>
              </Label>
              <Input
                type="file"
                placeholder="upload cv"
                name="cv"
                onChange={handleChange}
                required
                className={`cursor-pointer text-neutral-900 focus:outline-none w-full dark:text-neutral-200 rounded-none`}
              />
            </div>
            <div>
              <Label>
                Message{" "}
                <span className="text-red-500">*</span>
              </Label>
              <Textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                maxLength={600}
                rows={4}
                className={`text-neutral-900 focus:outline-none w-full dark:text-neutral-200 rounded-none`}
              />
            </div>
            <Button
              type="submit"
              className="rounded-none w-36"
              disabled={loading}
            >
              {loading ? (
                <Loader className="size-5 animate-spin duration-500" />
              ) : (
                <span>SUBMIT</span>
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
